import React from 'react'
import { Container } from 'react-bootstrap'

const AiIntegration = () => {
    return (
        <Container>
            <div className="card mb-3 shadow-sm m-5">
                <div className="card-body">
                    <h4 className="card-title fw-bold fs-5 mb-3">Quick Reply: Simplify and Speed Up Your Responses</h4>
                    <p>The Quick Reply feature in ChatInject is designed to make responding to customer messages faster, easier, and more consistent. With Quick Replies, you can create predefined responses to frequently asked questions or common scenarios, saving you time and ensuring a professional tone every time</p>


                    <h1 className='mt-4'>What Are Quick Replies?</h1>
                    <p>Quick Replies are pre-written messages that you can insert into a conversation with just a few clicks or keystrokes. They’re ideal for:</p>

                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Responding to common questions like operating hours, pricing, or services offered.</p>
                        </li>
                        <li class="mt-2">
                            <p>Sending acknowledgment messages like “Thank you for reaching out!”</p>
                        </li>
                        <li class="mt-2">
                            <p>Sharing promotional offers or links quickly.</p>
                        </li>
                    </ul>


                    <h1 className='mt-4'>1. Simple Setup</h1>
                    <h2 className='mt-2'>Create Quick Replies Effortlessly:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Navigate to the <strong>Quick Replies</strong> section in your account settings.</p>
                        </li>
                        <li class="mt-2">
                            <p>Click <strong>Add New Quick Reply</strong>, give it a title (e.g., “Welcome Message”), and type the message.</p>
                        </li>
                        <li class="mt-2">
                            <p>Save the Quick Reply, and it’s ready to use.</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>Example Messages:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>"Thank you for your inquiry! We’ll get back to you shortly."</p>
                        </li>
                        <li class="mt-2">
                            <p>"Our business hours are Monday to Friday, 9 AM to 6 PM."</p>
                        </li>
                        <li class="mt-2">
                            <p>"Click here to track your order: [insert link]."</p>
                        </li>
                    </ul>

                    <h1 className='mt-4'>2. Real-Time Usability</h1>

                    <h2 className='mt-2'>Instant Access in Chats:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>While replying to a message, type <strong>/</strong> in the input box. A dropdown menu with all your Quick Replies will appear.</p>
                        </li>
                        <li class="mt-2">
                            <p>Scroll through or search for the desired Quick Reply by typing its title or keywords.</p>
                        </li>
                        <li class="mt-2">
                            <p>Select the Quick Reply, and it will instantly populate in the message input box.</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>Platform-Specific Flexibility:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Use Quick Replies seamlessly across all connected platforms—WhatsApp, Instagram, Facebook, and Telegram.</p>
                        </li>
                        <li class="mt-2">
                            <p>Customize platform-specific replies if needed (e.g., "DM us on Instagram for more info!" vs. "Reply to this WhatsApp message for assistance.")</p>
                        </li>
                    </ul>
                    <h1 className='mt-4'>3. Easy Management</h1>

                    <h2 className='mt-2'>Edit or Delete Quick Replies Anytime:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Need to update a message? Simply go to the <strong>Quick Replies</strong> settings, select the reply you want to edit, make changes, and save.</p>
                        </li>
                        <li class="mt-2">
                            <p>To remove an outdated message, delete it with a single click.</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>Categorize Quick Replies for Organization:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Group similar replies (e.g., Support, Sales, Promotions) for easy navigation.</p>
                        </li>
                    </ul>

                    <h1 className='mt-4'>How to Use Quick Replies in Conversations</h1>

                    <h2 className='mt-2' >While Responding to a Message:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Open a chat window from any platform (e.g., WhatsApp, Instagram).</p>
                        </li>
                        <li class="mt-2">
                            <p>Type <strong>/</strong> to bring up the Quick Reply menu.</p>
                        </li>
                        <li class="mt-2">
                            <p>Search or scroll to find the appropriate reply.</p>
                        </li>
                        <li class="mt-2">
                            <p>Click on the Quick Reply to insert it into the message box.</p>
                        </li>
                        <li class="mt-2">
                            <p>Customize the message further (if needed) before hitting Send.</p>
                        </li>
                    </ul>

                    <h2 className='mt-4'>When Sending Promotional Campaigns:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Use Quick Replies to send consistent promotional messages to multiple customers.</p>
                        </li>
                        <li class="mt-2">
                            <p>Example: “We’re offering 20% off this week! Shop now: [insert link].”</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>During High-Volume Chats:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Handle peak hours with ease by using Quick Replies for common inquiries, reducing typing effort and response time.</p>
                        </li>
                    </ul>

                    <h1 className='mt-4'>Benefits of Quick Replies</h1>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p><strong>Save Time:</strong> No need to type the same response repeatedly—just click and send.</p>
                        </li>
                        <li class="mt-2">
                            <p><strong>Ensure Consistency:</strong> Maintain a uniform tone and message quality across all interactions.</p>
                        </li>
                        <li class="mt-2">
                            <p><strong>Boost Productivity:</strong> Respond to more customers in less time, especially during busy hours.</p>
                        </li>
                        <li class="mt-2">
                            <p><strong>Enhance Customer Experience:</strong> Quick responses lead to higher customer satisfaction and engagement.</p>
                        </li>
                    </ul>

                    <h1 className='mt-4'>Advanced Quick Reply Features</h1>

                    <h2 className='mt-2'>Smart Suggestions:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>ChatInject’s AI can suggest relevant Quick Replies based on the context of the customer’s message.</p>
                        </li>
                        <li class="mt-2">
                            <p>Example: If a customer asks, “What are your business hours?” the system will automatically suggest your predefined hours reply.</p>
                        </li>
                    </ul>

                    <h2 className='mt-4'>User-Specific Replies:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Tailor Quick Replies to specific user groups.</p>
                        </li>
                        <li class="mt-2">
                            <p>Example: VIP customers can receive personalized replies like, “As a valued VIP member, here’s your exclusive discount code: VIP2024.”</p>
                        </li>
                    </ul>

                    <h2 className='mt-4'>Analytics for Quick Replies:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Track the usage of Quick Replies to identify frequently asked questions.</p>
                        </li>
                        <li class="mt-2">
                            <p>Adjust your predefined messages to align with common customer needs and improve communication.</p>
                        </li>
                    </ul>

                    <h1 className='mt-2'>How to Set Up Quick Replies in ChatInject</h1>

                    <h2 className='mt-2'>Navigate to Quick Replies Settings:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Open your dashboard and click on <strong>Settings → Quick Replies</strong>.</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>Add a New Quick Reply:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Click the <strong>Add New</strong> button.</p>
                        </li>
                        <li class="mt-2">
                            <p>Enter a <strong>Title</strong> to identify the Quick Reply.</p>
                        </li>
                        <li class="mt-2">
                            <p>Write the message content.</p>
                        </li>
                        <li class="mt-2">
                            <p>Choose the platforms (e.g., Instagram, Facebook) where this Quick Reply should be available.</p>
                        </li>
                        <li class="mt-2">
                            <p>Save the reply.</p>
                        </li>
                    </ul>

                    <h2 className='mt-2'>Organize and Manage Replies:</h2>
                    <ul class="pl-6">
                        <li class="mt-2">
                            <p>Use categories to organize your replies (e.g., Support, Marketing, General).</p>
                        </li>
                        <li class="mt-2">
                            <p>Reorder replies for faster access to frequently used ones.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </Container>
    )
}

export default AiIntegration
